'use es6';

import { debounce } from 'ecosystem-marketplace-core/utils/debounce';
import * as ActionTypes from '../actions/ActionTypes';
import { SEARCH_KEY, MINIMUM_SEARCH_LENGTH } from 'marketplace-ui-reviews/constants/ReviewsListQueries';
import { getReviewFilters } from '../selectors/reviews';
import { fetchReviews } from '../actions/ReviewsActions';
const debouncedUpdate = debounce((dispatch, ...args) => dispatch(...args));
export default (({
  dispatch,
  getState
}) => next => action => {
  const result = next(action);

  if (result.type === ActionTypes.REVIEW_FILTERS_UPDATED) {
    const searchQuery = getReviewFilters(getState()).toSearchQuery();

    if (result.payload.updates[SEARCH_KEY]) {
      const {
        search
      } = searchQuery;

      if (!search || search.length < MINIMUM_SEARCH_LENGTH) {
        searchQuery.search = undefined;
      }

      debouncedUpdate(dispatch, fetchReviews(searchQuery, result.payload.reviewTypes));
    } else {
      dispatch(fetchReviews(searchQuery, result.payload.reviewTypes));
    }
  }

  return result;
});